
const loadCaptchaBasic = () => import('captcha_basic').then(module => module.default);
export const basic_captcha = loadCaptchaBasic
const loadEmbedBasic = () => import('embed-basic').then(module => module.default);
export const basic_embed = loadEmbedBasic
const loadQuickLinks = () => import('quick-links').then(module => module.default);
export const quick_links = loadQuickLinks
const loadRenderMarkdownCodehighlight = () => import('render-markdown-codehighlight').then(module => module.default);
export const render_markdown_codehighlight = loadRenderMarkdownCodehighlight